import { useTranslation } from "react-i18next";
import UiLanguageSelect from "./UiLanguageSelect";
// StepHeader.tsx
import React from "react";
import { ArrowLeftIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { A } from "../styles/appleClasses"; // adjust path if needed

export default function StepHeader({
  title,
  showBack = true,
  onBack,
  onClose,
}: {
  title: string;
  showBack?: boolean;
  onBack?: () => void;
  onClose?: () => void;
}) {
  const { t } = useTranslation();
  const iconBtn = [
    A.iconBtn, // ✅ canonical 10x10 rounded-xl
    "inline-flex items-center justify-center",
    "hover:bg-gray-100 transition",
    "focus:outline-none focus:ring-2 focus:ring-appleblueD",
    "disabled:opacity-50 disabled:cursor-not-allowed",
  ].join(" ");

  const closeDisabled = typeof onClose !== "function";
  const backDisabled = !showBack || typeof onBack !== "function";

  return (
    <div>
      <div className="mb-4 flex justify-end"><UiLanguageSelect /></div>
      <div className="flex items-center justify-between mb-6 h-10">
      {/* Back Arrow */}
      {showBack ? (
        <button
          type="button"
          aria-label={t("directory.common.back")}
          className={iconBtn}
          onClick={onBack}
          disabled={backDisabled}
        >
          <ArrowLeftIcon className="w-5 h-5 text-gray-500" />
        </button>
      ) : (
        <div className={A.iconBtn} />
      )}

      {/* Title */}
      <h1 className={`flex-1 text-center leading-tight px-2 truncate ${A.title}`}>
        {title}
      </h1>

      {/* Close/X */}
      <button
        type="button"
        aria-label={t("onboarding.common.exit")}
        className={iconBtn}
        onClick={onClose}
        disabled={closeDisabled}
      >
        <XMarkIcon className="w-5 h-5 text-gray-500" />
      </button>
      </div>
    </div>
  );
}
